import React, { useEffect } from 'react';
import { Button } from '../ui';

/* Slide-over drawer used by the PIM admin + editor screens. */
export default function Drawer({ title, sub, onClose, footer, children }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="pim-drawer-backdrop" role="presentation" onClick={onClose}>
      <div
        className="pim-drawer"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pim-drawer-head">
          <div>
            <h2>{title}</h2>
            {sub && <p>{sub}</p>}
          </div>
          <Button variant="ghost" onClick={onClose} aria-label="Close">
            ✕
          </Button>
        </div>
        <div className="pim-drawer-body">{children}</div>
        {footer && <div className="pim-drawer-foot">{footer}</div>}
      </div>
    </div>
  );
}
